// extracted by mini-css-extract-plugin
export default {"scroll_up_button":"scrollUp_scroll_up_button__aa5Gj","scroll_up_button_icon":"scrollUp_scroll_up_button_icon__vvcgB"};